/**
 * Permits whole numbers, as well as decimals up to two decimal places.
 */
export const CARBON_AVOIDANCE_AMOUNT_REGEX = /^\d*(\.\d{0,2})?$/;

/**
 * Permits whole numbers only, between 2 and 5 characters in length.
 */
export const PROJECT_ID_REGEX = /^\d{2,5}$/;

/**
 * Used for constraining the User.link field, see https://stackoverflow.com/a/3809435
 */
export const WEBSITE_URL_REGEX =
  /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/;
